var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.803 75.319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3-54.314a3.462,3.462,0,0,0,1.5-.724c4.893-3.228,8.156-7.133,8.156-11.027,0-3.779-2.642-6.249-5.675-6.249a4.362,4.362,0,0,0-3.986,2.5,4.381,4.381,0,0,0-3.986-2.5c-3.033,0-5.675,2.47-5.675,6.249,0,3.894,3.262,7.8,8.144,11.027A3.553,3.553,0,0,0,18.3-54.314Z",
    transform: "translate(0 0)",
    fill: "#c10000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFill);
export default __webpack_public_path__ + "static/media/heartFill.d81e9ebc84322564c813c4927b301560.svg";
export { ForwardRef as ReactComponent };